// extracted by mini-css-extract-plugin
export default {"pageGrid":"styles_pageGrid__5PVWj","doughnutChartTile":"styles_doughnutChartTile__OQDSW"};